import ExtensibilityState from './schema/ExtensibilityState';
import getExtensibilityState from './getExtensibilityState';
import TaskPaneRunningInstance from './schema/TaskPaneRunningInstance';

export default function getAllActiveControlIds(hostItemIndex: string): string[] {
    const state = getExtensibilityState();
    const taskPaneIds = getTaskPaneControlIds(hostItemIndex, state);
    const uilessIds = getUilessControlIds(hostItemIndex, state);
    const contextualIds = getContextualControlIds(hostItemIndex, state);
    return [...taskPaneIds, ...uilessIds, ...contextualIds];
}

function getTaskPaneControlIds(hostItemIndex: string, state: ExtensibilityState): string[] {
    return [...state.taskPanes.values()]
        .filter((taskPane: TaskPaneRunningInstance) => taskPane.hostItemIndex === hostItemIndex)
        .map((taskPane: TaskPaneRunningInstance) => taskPane.controlId);
}

function getUilessControlIds(hostItemIndex: string, state: ExtensibilityState): string[] {
    const uilessAddins = state.runningUILessAddinCommands;
    if (uilessAddins.has(hostItemIndex)) {
        return [...uilessAddins.get(hostItemIndex).keys()];
    }
    return [];
}

function getContextualControlIds(hostItemIndex: string, state: ExtensibilityState): string[] {
    const contextualAddins = state.runningContextualAddinCommand;
    if (contextualAddins && contextualAddins.hostItemIndex === hostItemIndex) {
        return [state.runningContextualAddinCommand.controlId];
    }
    return [];
}
